<template lang="html">
  <div class="main form-container">
    <h2>Nuevo analisis de Portafolio</h2>
    <el-form :model="generalData" status-icon :rules="formRules" ref="generalData">
      <breadcrumbs class="breadcrumbs" section="1"></breadcrumbs>
      <h3 class="second-title">Información general</h3>
      <el-form-item label="Alias" prop="alias" class="alias-input">
        <el-autocomplete :fetch-suggestions="fetchClients" :trigger-on-focus="false" prefix-icon="el-icon-edit"
        v-model="selectedClient" @select="handleClientSelect">
        <template slot-scope="{ item }">
          <span class="link" :value="item.value">{{ item.alias }}</span>
        </template>
        </el-autocomplete>
      </el-form-item>

      <el-form-item label="No. de contrato" prop="contract_number">
        <el-tooltip content="Se encuentra en el estado de cuenta por analizar en la parte superior" placement="top">
          <i class="el-icon-question label-tooltip"></i>
        </el-tooltip>
        <el-input placeholder="" prefix-icon="el-icon-edit" v-model="generalData.contract_number"></el-input>
      </el-form-item>

      <!-- Investor Profile input for version 2 -->
      <!-- <el-form-item prop="investor_profile">
        <h3>Perfíl de inversionista</h3>
        <el-tooltip content="Perfíl de inversionista es..." placement="top">
          <i class="el-icon-question label-tooltip"></i>
        </el-tooltip>
        <el-select v-model="generalData.investor_profile" placeholder="Select">
          <el-option
          v-for="item in profileOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="Correo electrónico (opcional)" prop="email">
        <el-input placeholder="" prefix-icon="el-icon-edit" v-model.trim="generalData.email"></el-input>
      </el-form-item>

      <el-form-item label="Fecha de corte" prop="cutoff_date">
        <el-date-picker v-model="generalData.cutoff_date" type="month" value-format="yyyy-MM-dd"  placeholder="AAAA-MM" :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="container-continue-button" v-on:click="validateForm('generalData')">
      <p class="continue-button">Continuar</p>
      <i class="el-icon-arrow-right blue-arrow-icon"></i>
    </div>
  </div>
</template>

<script>
import breadcrumbs from './Breadcrumbs';
import { getClientsByAdvisor, createClient, getLastDataDate } from '@/graphql'
export default {
  components: {
    breadcrumbs
  },
  mounted(){
    const previousData = this.getPreviousData()
    this.fetchLastDate()
    if (previousData) {
      this.generalData = previousData
      this.selectedClient = previousData.alias
    }
  },
  computed: {
    advisorId: function () {
      return this.$store.getters.userInfo.id
    },
    pickerOptions: function () {
      return {
        disabledDate: this.disabledDate
      }
    },
  },
  data() {
    return {
      formRules: {
        alias: [
          { required: true, message: 'Debes proporcionar un alias', trigger: 'blur' },
          { max: 25, message: "El alias es demasiado largo", trigger: "blur" }
        ],
        contract_number: [
          { required: true, message: 'Debes proporcionar un número de contrato', trigger: 'blur' }
        ],
        email: [
          { required: false, type: 'email', message: 'Es necesario un email válido, ejemplo@email.com', trigger: 'blur' }
        ],
        cutoff_date: [
          { required: true, message: 'Debes proporcionar una fecha de corte', trigger: 'blur' }
        ]
      },
      profileOptions: [
        {
          value: 'Básico',
          label: 'Básico'
        }, {
          value: 'Patrimonial',
          label: 'Patrimonial'
        }, {
          value: 'Balanceado',
          label: 'Balanceado'
        }, {
          value: 'Crecimiento',
          label: 'Crecimiento'
        },
      ],
      generalData: {
        email:'',
        investor_profile:'',
        contract_number:'',
        cutoff_date:'',
        alias:'',
        clientId: 0
      },
      advisorClients: [],
      selectedClient: '',
      acceptedMinDate: ''
    }
  },
  watch: {
    selectedClient: function (value) {
      if (value !== this.generalData.alias) {
        // Reset inputs if it is a new client
        this.generalData.email = ''
        this.generalData.clientId = 0
      }
      this.generalData.alias = value
    },
  },
  methods: {
    fetchLastDate () {
      this.$apollo.query({
        query: getLastDataDate,
        fetchPolicy: 'network-only'
      }).then((data) => this.acceptedMinDate = data.data.getLastDataDate
        ).catch((error) => { console.log(error) })
    },
    getPreviousData () {
      return this.$store.getters.getGeneralData
    },
    validateForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // New client case
          if (this.generalData.clientId === 0) {
            this.createNewClient()
          } else {
            this.goToNextStep()
          }
        } else {
          return false
        }
      })
    },
    fetchClients (inputQuery, callback) {
      this.$apollo.query({
        query: getClientsByAdvisor,
        variables: {
          advisorId: this.advisorId
        },
        fetchPolicy: 'network-only'
      }).then((data) => this.filterClientsByQuery(callback, data.data.clientsByAdvisor, inputQuery)
        ).catch((error) => { console.log(error) })
    },
    filterClientsByQuery(callback, clients, inputQuery) {
      this.advisorClients = clients
      // Filter by input query
      const filteredClients = inputQuery ?
        clients.filter(client => client.alias.includes(inputQuery)) : clients
      // Callback function to return suggestions
      callback(filteredClients);
    },
    handleClientSelect (client) {
      this.selectedClient = client.alias
      this.generalData.alias = client.alias
      this.generalData.clientId = parseInt(client.id)
      this.generalData.email = client.email
    },
    createNewClient (clientInfo) {
      this.$apollo.mutate({
        mutation: createClient,
        variables: {
          advisorId: this.advisorId,
          alias: this.generalData.alias,
          email: this.generalData.email
        }
      }).then((data) => {
        if (data.data.createClient.returnCode === 2) {
          this.$message({
            type: 'error',
            message: 'Ya existe un cliente con este alias'
          })
        } else {
          this.generalData.clientId = parseInt(data.data.createClient.client.id)
          this.goToNextStep()
        }
        }).catch((error) => { console.log(error) })
    },
    goToNextStep () {
      // Primero guarda al store y luego redirige
      this.$store.dispatch( 'saveGeneralData' , this.generalData ).then(this.$router.push('registro-emisoras'));
    },
    disabledDate(date) {
      const disableDate = new Date(this.acceptedMinDate)
      return date >= disableDate
    }
  },
}
</script>
<style scoped lang="css">

.el-form {
  display: flex;
  flex-direction: column;
}

.el-form-item {
  margin-bottom: 40px;
}

.el-select,
.el-autocomplete {
  width: 100%;
}

/* Styles for the label tooltip */
.label-tooltip {
  display: inline-block;
  background-color: white;
}

/* Styles for the dropdown menu */

.el-button-group .el-button:not(:last-child) {
  width: 100%;
  height: 40px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 0;
}

.el-dropdown .el-button-group {
  width: 100%;
}

.el-dropdown {
  width: 100%;
}

.el-button-group .el-button:last-child {
  position: absolute;
  right: 0;
}

.el-dropdown__icon {
  font-size: 14px;
  font-weight: 1000;
}

a {
  text-decoration: none;
}

p {
  margin: 0px;
}

hr {
  border-color: #4366DE;
  margin: 0px;
  margin-bottom: 2px;
}

h2 {
  margin: 0;
}

h3 {
  font-weight: 400;
  display: inline-block;
  margin: 0;
}

.second-title {
  text-align: center;
  margin-bottom: 3em;
  font-size: 22px;
  font-weight: 600;
}

.subtitle {
  font-size: 22px;
  margin-bottom: 8px;
  margin-top: 18px;
}

.text-question {
  text-decoration: underline;
  cursor: pointer;
  margin-top: 6px;
  margin-left: auto;
  margin-right: 0px;
  display: block;
  width: 126px;
}

.blue-button {
  background-color: #4366DE;
  color: white;
  text-align: center;
  height: 38px !important;
  cursor: pointer;
  border-radius: 3px;
}

.blue-button p {
  padding: 10px;
}

.label {
  margin-top: 16px;
}

.main {
  display: block;
  margin: auto;
  width: 100%;
  max-width: 720px;
  margin-top: 2rem;
  padding: 1rem;
  box-sizing: border-box !important;
}

.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  height: 28px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.el-input__inner {
  height: 38px;
}

/* Style for the table */

.el-main {
  line-height: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.el-table {
  font-size: 12px;
  text-align: left;
}

/* Style for the cross icon */

.el-icon-circle-close-outline {
  float: right;
  font-size: 20px;
  cursor: pointer;
}

/* Style for breadcrumbs component */

.breadcrumbs {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

/* Style for date component */

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}

.container-continue-button {
  display: block;
  width: 142px;
  margin-left: auto;
  margin-right: 0px;
  margin-top: 3em;
  margin-bottom: 3em;
}

.continue-button {
  cursor: pointer;
  margin-top: 6px;
  margin-left: auto;
  margin-right: 0px;
  display: inline-block;
  width: 86px;
  font-weight: 500;
  font-size: 22px;
  color: #4366DE;
}

.blue-arrow-icon {
  font-size: 22px;
  font-weight: 600;
  color: #4366DE;
  position: relative;
  top: 3px;
  margin-left: 26px;
}

</style>



// WEBPACK FOOTER //
// src/components/RegisterGeneralData.vue